import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import fetchWrapper from "../../api/fetchWrapper";
import { ENDPOINT } from "../../api/endpoint";
import { tabName } from "../../utils/constants";
import { v4 as uuidv4 } from 'uuid';

export const useExportRecordData = (activeTab: number) => {
  const uuid = uuidv4();
  const { selectedFilter } = useSelector((state: RootState) => state.filter);
  const initialInterval = 15000;
  const maxAttempts = 30; 
  const exportRecordData = async () => {
    const body = {
      reviewType: selectedFilter?.reviewType,
      selectedRegions: selectedFilter?.selectedRegions,
      startDate: selectedFilter?.startDate,
      endDate: selectedFilter?.endDate,
      selectedCountries: selectedFilter?.selectedCountries,
      selectedAffiliates: selectedFilter?.selectedAffiliates,
      selectedEvaluation: selectedFilter?.selectedEvaluation,
      selectedRisk: selectedFilter?.selectedRisk,
      selectedStatus: selectedFilter?.selectedStatus,
      selectedProduct: selectedFilter?.selectedProduct,
      selectedSampleId: selectedFilter?.selectedSampleId,
      tab: tabName[activeTab],
      exportId: uuid
    };
    // Replace this with your actual API endpoint and logic.
      fetchWrapper(ENDPOINT.EXPORT_RECORD, {
      method: "POST",
      body: JSON.stringify(body),
    });

    await new Promise((res) => setTimeout(res, 5000));
    const pollResponse = await pollFetchResults(uuid);
  
    return pollResponse;
  };
  const pollFetchResults = async (exportId: string) => {
      let attempts = 0;

      while (attempts < maxAttempts) {
        attempts++;

        const pollBody = { exportId };
        const response = await fetchWrapper(ENDPOINT.EXPORT_POLL_DATA, {
          method: "POST",
          body: JSON.stringify(pollBody),
        });

        const status = String(response?.status ?? "").toLowerCase();
        if (status === "completed") {
          if (response?.preSignedURL) {
            const r = await fetch(response.preSignedURL, {
              method: "GET",
              credentials: "omit",
              mode: "cors",
              headers: { Accept: "application/json" },
            });
            if (!r.ok) throw new Error(`Pre-signed URL fetch failed: ${r.status}`);
            return r.json();
          }
          return response?.data ?? response;
        }

        if (status === "failed") {
          throw new Error(response?.message ?? "Export failed");
        }

        await new Promise((res) => setTimeout(res, initialInterval));
      }

      throw new Error("Polling timed out");
  };

  return { exportRecordData };
};
